import React from 'react'

import Layout from '../App/layout'
import ContentLayout from '../../components/utility/layoutContent'
import LayoutContentWrapper from '../../components/utility/layoutWrapper'
import ProjectsIndexContainer from './ProjectsIndexContainer'

class ProjectIndexPage extends React.Component {
    componentDidMount() {
        document.title = 'Projects | OSH CRM'
    }

    render () {
        return (
            <Layout>
                <LayoutContentWrapper breadcrumbs={[
                        { path: '/projects', name: 'Projects' }
                    ]}>
                    <ContentLayout>
                        <ProjectsIndexContainer />
                    </ContentLayout>
                </LayoutContentWrapper>
            </Layout>
        )
    }
}

export default ProjectIndexPage
